module.exports = __webpack_public_path__ + "fonts/Century Gothic.cfce6abb.ttf";